import { render, staticRenderFns } from "./MakeRequestJoinForm.vue?vue&type=template&id=67219a84&scoped=true&"
import script from "./MakeRequestJoinForm.vue?vue&type=script&lang=js&"
export * from "./MakeRequestJoinForm.vue?vue&type=script&lang=js&"
import style0 from "./MakeRequestJoinForm.vue?vue&type=style&index=0&id=67219a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67219a84",
  null
  
)

export default component.exports